import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from '@shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { FormWidgetCompanyComponent } from '@modules/bcm/@work-flows/@form-widgets/company/form-widget-company.component';
import { HtmlLinksModule } from '@modules/bcm/@shared/components/html-links/html-links.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
    TenantRelationColoredLabelModule
} from '@modules/bcm/@shared/components/tenant-relation-colored-label/tenant-relation-colored-label.module';
import { CompanyEditorDialogComponent } from './company-editor-dialog/company-editor-dialog.component';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { TranslationModule } from '@core/translation/translation.module';

@NgModule({
    declarations: [FormWidgetCompanyComponent, CompanyEditorDialogComponent],
    imports: [
        FuseSharedModule,
        SharedModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
        HtmlLinksModule,
        MatProgressSpinnerModule,
        MatAutocompleteModule,
        MatTooltipModule,
        TenantRelationColoredLabelModule,
        CdkDrag,
        CdkDragHandle,
        TranslationModule,
    ],
    exports: [FormWidgetCompanyComponent]
})
export class FormWidgetCompanyModule {
    
}
